export default "__VITE_ASSET__DhvVpHWv__"